import { VoxRoutes } from './index';
import { KitRoutes } from './kit_router';
import { currentInstance } from '@/heplers';

const isRootRouteRegex = new RegExp('docs$');

export const getMainPageName = () => {
  const voxMainPage = VoxRoutes.find((route) => isRootRouteRegex.test(route.path))?.name;
  const kitMainPage = KitRoutes.find((route) => isRootRouteRegex.test(route.path))?.name;
  return currentInstance === 'vox' ? voxMainPage : kitMainPage;
};
